/**
 * Trigger Source Types - HOW a claim is triggered (the touchpoint mechanism)
 *
 * This defines the physical/digital interaction method for triggering claims.
 * NOT to be confused with CampaignTriggerType which defines WHO can claim.
 *
 * Relationship:
 * - campaign.trigger.triggerType → WHO can claim (CLAIM_BY_USER, CLAIM_BY_BUSINESS, CLAIM_BY_SYSTEM)
 * - campaign.triggerSources[].type → HOW to claim (QR_CODE, NFC_TAG, GPS_GEOFENCE, etc.)
 *
 * Access via: campaign.included?.triggerSources?.map(ts => ts.type)
 *
 * App Integration Guide:
 * - QR_CODE: Open camera/scanner, decode QR, extract triggerSourceId
 * - NFC_TAG: Activate NFC reader, read tag data, extract triggerSourceId
 * - GPS_GEOFENCE: Get user location, send latitude/longitude with claim
 * - API_WEBHOOK: Server-to-server, external system triggers claim
 * - TRANSACTION: Triggered by purchase events (Stripe, POS, etc.)
 *
 * NOTE: A campaign can have MULTIPLE trigger sources of different types.
 * Example: Same campaign claimable via QR_CODE OR NFC_TAG at different locations.
 *
 * Using const object pattern for better extensibility without requiring deploys
 *
 * @see CampaignTriggerType for WHO can initiate claims
 * @see CampaignClaimRequestDTO for the claim payload structure
 */
export const TRIGGER_SOURCE_TYPES = {
    /** Physical QR code scan. App opens camera, decodes QR, extracts triggerSourceId */
    QR_CODE: 'QR_CODE',
    /** NFC tag tap. App activates NFC reader, reads tag data, extracts triggerSourceId */
    NFC_TAG: 'NFC_TAG',
    /** Server-to-server webhook. External system triggers claim via API */
    API_WEBHOOK: 'API_WEBHOOK',
    /** GPS-based geofence entry. App sends user coordinates for proximity validation */
    GPS_GEOFENCE: 'GPS_GEOFENCE',
    /** Purchase/transaction triggered. Claim activated by payment events */
    TRANSACTION: 'TRANSACTION',
};
// Export values array for validation
export const TRIGGER_SOURCE_TYPE_VALUES = Object.values(TRIGGER_SOURCE_TYPES);
/**
 * Source Logic Types
 * Defines how multiple trigger sources combine to activate a flow
 * Currently only ANY (OR logic) is implemented
 */
export const SOURCE_LOGIC_TYPES = {
    ANY: 'any'
    // Future: ALL: 'all', SEQUENCE: 'sequence', WEIGHTED: 'weighted'
};
export const SOURCE_LOGIC_TYPE_VALUES = Object.values(SOURCE_LOGIC_TYPES);
//# sourceMappingURL=trigger-source-type.enum.js.map